import { render, staticRenderFns } from "./productionView.vue?vue&type=template&id=60f915d2&scoped=true"
import script from "./productionView.vue?vue&type=script&lang=js"
export * from "./productionView.vue?vue&type=script&lang=js"
import style0 from "./productionView.vue?vue&type=style&index=0&id=60f915d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f915d2",
  null
  
)

export default component.exports